import { Component } from 'react';
import { Sentry } from '../sentry';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError = error.message?.includes('Failed to fetch dynamically imported module') ||
                         error.message?.includes('Loading chunk') ||
                         error.message?.includes('Loading CSS chunk') ||
                         error.name === 'ChunkLoadError';
    return { hasError: true, isChunkError };
  }

  componentDidCatch(error, errorInfo) {
    // No reportamos chunk errors — son esperados tras deploys y se resuelven con reload.
    if (this.state.isChunkError) return;
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-50">
          <div className="text-center max-w-sm">
            <p className="text-6xl mb-4">🔄</p>
            <h2 className="text-lg font-bold text-gray-800 mb-2">
              {this.state.isChunkError ? 'Nueva versión disponible' : 'Algo salió mal'}
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              {this.state.isChunkError
                ? 'Hay una actualización disponible. Toca el botón para cargar la nueva versión.'
                : 'Ocurrió un error inesperado. Intenta recargar la página.'}
            </p>
            <button
              onClick={this.handleReload}
              className="bg-brand-primary text-white px-6 py-3 rounded-full font-semibold text-sm shadow-lg"
            >
              Actualizar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
